import { IconShoppingCart } from "@tabler/icons-react";
import React from "react";
import { useTranslations } from "../../../helpers/translations";
import { useUserContext } from "../../../providers/UserProvider";
import { RAILS_ROUTES } from "../helpers/routes";

export const CartStatus = () => {
  const { currentUserAll } = useUserContext();
  const t = useTranslations("nav.cart");

  const cartItemCount = currentUserAll?.data?.userCart.item?.itemsCount ?? 0;

  return (
    <a
      href={RAILS_ROUTES.CHECKOUT_CART}
      className="relative flex text-gray-400 hover:text-white py-md px-xs"
      data-testid="cart-status-link"
      aria-label={t("ariaLabel")}
    >
      <IconShoppingCart width={32} />
      {cartItemCount > 0 && (
        <span className="absolute size-2xl -top-xs -right-xs flex items-center justify-center rounded-full text-xs-medium bg-red-500 text-white">
          {cartItemCount}
        </span>
      )}
    </a>
  );
};
